<button type="button"
		[ngClass]="{'disabled': disabled}"
		[disabled]="disabled">
	<ng-content></ng-content>
</button>
